import { observer } from 'mobx-react-lite';
import { QueueStateContext } from '../queues/context/queue-state-context';
import { useIntegratedEventQueueStore } from './use-integrated-event-queue-store';

export const EventQueueStateProvider = observer(function EventQueueStateProvider(props: {
    children: React.ReactNode;
}) {
    const { store } = useIntegratedEventQueueStore();
    return <QueueStateContext.Provider value={store}>{props.children}</QueueStateContext.Provider>;
});
